import Spinner from '../components/Spinner'
import { Auth, Logger } from "aws-amplify"

const logger = new Logger("GetS3Object")

const AWS = require("aws-sdk")

const GetS3Object = {
  template: `
    <div :style="theme.container">
      <router-view></router-view>
    </div>
  `,
  getObject: (credentials, bucketName, key) => {
    return new Promise((resolve, reject) => {
      // console.dir(credentials)
      const s3 = new AWS.S3({
        apiVersion: '2006-03-01',
        region: 'ap-northeast-1',
        credentials: Auth.essentialCredentials(credentials)
      })
      s3.getObject({
        Bucket: bucketName, // process.env.S3_BUCKET_NAME,
        Key: key // FILE_NAME
      }, (err, data) => {
        if (err) {
          console.dir(err)
          reject(new Error("S3からファイルを取得できません"))
        }
        const contents = JSON.parse(data.Body.toString())
        resolve(contents)
      })
    })
  },
  get: (bucketName, key) => {
    return Spinner.show()
      .then(() => {
        logger.debug("GetS3Object...")
        return Auth.currentCredentials()
      }).then(credentials => {
        return GetS3Object.getObject(credentials, bucketName, key)
      })
  }
}

export default GetS3Object



// WEBPACK FOOTER //
// ./src/logic/GetS3Object.js